function Input({ value, setValue, placeholder, ...props }) {
  function handleChange(e) {
    setValue(e.target.value)
  }

  return (
    <input
      className="input"
      value={value}
      onChange={(e) => handleChange(e)}
      placeholder={placeholder}
      {...props}
    />
  )
}

export default Input
